<a
  (click)="
    modalService.open(information, {
      size: 'xl',
      centered: true,
      windowClass: 'xxl-modal',
    })
  "
  href="javascript:void(0)"
>
  <svg-icon name="info" svgClass="icon x1-5 sanakey-color fill"></svg-icon>
</a>

<!-- Header Definition -->
<ng-template #modalHeaderPrint let-modal="modal" let-title="title">
  <div class="modal-header">
    <h4 class="modal-title">
      {{ title }}&nbsp;
      <button
        [useExistingCss]="true"
        aria-label="drucken"
        class="btn btn-primary"
        ngxPrint
        printSectionId="print-section"
      >
        <fa-icon [icon]="printIcon"></fa-icon>
      </button>
    </h4>
    <button
      (click)="modal.dismiss()"
      aria-label="schließen"
      class="btn-close"
      type="button"
    ></button>
  </div>
</ng-template>
<!-- Info Modal -->
<ng-template #information let-modal>
  <ng-container
    *ngTemplateOutlet="
      modalHeaderPrint;
      context: { modal: modal, title: 'Kontaktmöglichkeiten' }
    "
  >
  </ng-container>
  <div class="p-3 pb-5 bg-light" id="print-section">
    <h4>
      Sie haben Fragen? Unser Team steht Ihnen gerne zur Verfügung. Sie
      erreichen uns am Besten per E-Mail:
    </h4>
    <div class="container">
      <div class="row">
        <san-visitenkarte
          abteilung="Allgemeine / technische Fragen zur Funktion des Sanakey-Portals®"
          class="col-xl-4 col-lg-6"
          email="service@sanakey-portal.de"
          servicezeiten="an Werktagen von 09:00 bis 15:00 Uhr"
          telefonnummer="030 3100 78 999 (Servicehotline der Sanakey-Gruppe)"
        ></san-visitenkarte>
        <san-visitenkarte
          abteilung="Fragen zur Abrechnung (Versorgungsverträge § 140a SGB V; Hybrid-DRG § 115f)"
          class="col-xl-4 col-lg-6"
          email="abrechnung@sanakey-contract.de"
          logo="assets/logos/sanakey-contract.png"
          servicezeiten="an Werktagen von 09:00 bis 15:00 Uhr"
          telefonnummer="030 3100 78 999 (Servicehotline der Sanakey-Gruppe)"
        ></san-visitenkarte>
      </div>
    </div>
    <h4 class="mt-3">Hilfe:</h4>
    <div class="container">
      <div class="row">
        <div class="col-xl-4 col-lg-6">
          <div (click)="goToAuthenticator()" class="sanakey-kachel hoverable">
            <strong>Einrichtung Authenticator App</strong>
          </div>
        </div>
        <div class="col-xl-4 col-lg-6 mt-2 mt-lg-0">
          <div (click)="goToFAQ()" class="sanakey-kachel hoverable">
            <strong>FAQ</strong>
          </div>
        </div>
        <div class="col-xl-4 col-lg-6 mt-2 mt-lg-2 mt-xl-0">
          <div
            (click)="goToTeamviewerDownload()"
            class="sanakey-kachel hoverable"
          >
            <strong>Fernwartung</strong>
            <small class="ms-auto"
            >Download nur in Absprache mit dem Service-Team.</small
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
